/**
 * Created by divyanshverma on 11/24/16.
 */
import moment from 'moment-timezone';
import * as _ from 'underscore';
import 'jquery-ui/ui/widgets/autocomplete';

const settings = {};
settings.timezone = "Asia/Kolkata";
settings.dateTimeFormat = "DD-MM-YYYY";

class GridRenderer {
    constructor(collection) {
      this.collection = collection;
    }
    
    move(x, y) {
        x = x;
        y = y;
    }
    
    returnHyperLinkPage(params) {
    
    }
    
    returnHyperLink(params) {
        // console.log(params);
        const cellvalue =  params.value;
        const _id = params.data._id;
        const collection = params.colDef._collection;
        if (_.isUndefined(cellvalue) || cellvalue === null)
            return "<a href='" + collection + "/" + _id + "' ></a>";
    
        if (cellvalue.toString().indexOf('T') > -1 && cellvalue.toString().indexOf('Z') > -1)
            return "<a href='" + collection + "/" + _id + "' >" + moment.tz(cellvalue, settings.timezone).format(settings.dateTimeFormat) + "</a>";
    
        if (typeof cellvalue === 'object')
            return "<a href='" + collection + "/" + _id + "' >" + cellvalue.label + "</a>";
    
        return "<a href='" + collection + "/" + _id + "' >" + cellvalue + "</a>";
    }
    
    returnHyperLinkNewWindow() {
    
    }
    
    fileviewNewWindow(){
    
    }
    
    password() {
    }
    
    unFormatReference() {
    }
    
    custom_datepicker() {
    
    }
    
    custom_datepicker_value(elem, op, v) {

    }
    
    autocomplete_element(col, storeId, root) {
    }
    
    autocomplete_value() {

    }
    
    dateTimeFormatter(params) {
        const cellvalue =  params.value;
        if (!_.isUndefined(cellvalue) && cellvalue != null) {
            if (cellvalue.indexOf('T') > -1 && cellvalue.indexOf('Z') > -1)
                return moment.tz(cellvalue, settings.timezone).format(settings.dateTimeFormat);
        
            return moment.tz(cellvalue, settings.dateTimeFormat, settings.timezone).format(settings.dateTimeFormat);
        }
        return "";
    }
    
    dateFormatter(params) {
        const cellvalue =  params.value;
        if (!_.isUndefined(cellvalue) && cellvalue != null) {
            if (cellvalue.indexOf('T') > -1 && cellvalue.indexOf('Z') > -1)
                return moment.tz(cellvalue, settings.timezone).format(settings.dateTimeFormat);
        
            return moment.tz(cellvalue, settings.dateTimeFormat, settings.timezone).format(settings.dateTimeFormat);
        }
        return "";
    }
    
    pickDateTime() {
    
    }
    
    pickDate() {
    
    }
    
    scriptFormatter() {

    }
    
    unformatScriptFormatter() {

    }
    
    gselectFormatter(params) {
        const cellvalue =  params.value;
        if (cellvalue && typeof cellvalue === 'object') {
            if (_.has(cellvalue, 'label') && _.has(cellvalue, 'value')) {
                return `<a href=${params.colDef.refer_collection}/${cellvalue.value}>${cellvalue.label}</a>`;
            } else {
                return "";
            }
        
        }
    
        if (_.isUndefined(cellvalue) || cellvalue === null)
            return "";
    
        if (typeof cellvalue === 'string') {
            return "<a href='" + params.colDef.refer_collection + "/" + cellvalue + "' >" + cellvalue + "</a>";
        }
    
    }
    
    multiSelect() {
    
    }
    
    unFormatMReference() {

    }
    
    generalFormatter(params) {
        return  params.value ? params.value.toString() : "";
    }
    
    optionFormatter() {

    }
    
    unformatOptions(cellvalue, options, cell) {

    }
    
    validatePositive() {

    }
    
    booleanFormatter() {
    
    }
    
    formatImage() {

    }
    
    imageUnFormat() {

    }
    
    processRules() {

    }
}

export default GridRenderer;
